/* eslint-disable no-new */

import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import announcer from './aria-announcer';

const elementMessage = 'Carrousel d\'éléments';
const nextElement = 'Élément suivant';
const prevElement = 'Élément précédent';

const getAdjacentSlidesLabels = (el) => {
    const slides = [...el.querySelectorAll('.swiper-slide')];
    const positionLabel = (slide) => (slide ? `${slides.indexOf(slide) + 1} / ${slides.length}` : '');
    return {
        prevLabel: positionLabel(el.querySelector('.swiper-slide-prev')),
        nextLabel: positionLabel(el.querySelector('.swiper-slide-next')),
    };
};

const baseA11yOptions = {
    enabled: true,
    containerMessage: elementMessage,
    containerRole: 'group',
    slideRole: '',
    slideLabelMessage: '',
    paginationBulletMessage: 'Aller à l\'élément {{index}}',
};

document.addEventListener('DOMContentLoaded', () => {
    const updateSlideAccessibility = ({ slides, activeIndex }) => {
        slides.forEach((slide, index) => {
            const isActive = index === activeIndex;
            slide.setAttribute('tabindex', isActive ? '0' : '-1');
            slide.setAttribute('aria-hidden', (!isActive).toString());
        });
    };

    const swiperBreakpoints = {
        768: { spaceBetween: 24, slidesPerView: 2 },
        1230: { spaceBetween: 24, slidesPerView: 3 },
        1600: { spaceBetween: 24, slidesPerView: 4 },
    };

    const swiperConfigs = [
        {
            selector: '.block-news-listing .swiper',
            messages: {
                next: 'Élément suivant',
                prev: 'Élément précédent',
            },
        },
        {
            selector: '.block-discounts-cards .swiper',
            messages: {
                next: 'Rabais suivant',
                prev: 'Rabais précédent',
            },
        },
        {
            selector: '.block-activities-cards .swiper',
            messages: {
                next: 'Activité suivante',
                prev: 'Activité précédente',
            },
        },
    ];

    const shouldEnableSwiperNavigation = (el) => {
        const numSlides = el.querySelectorAll('.swiper-slide').length;
        let slidesPerView = 1;
        const windowWidth = window.innerWidth;

        if (windowWidth >= 1600) {
            slidesPerView = 4;
        } else if (windowWidth >= 1230) {
            slidesPerView = 3;
        } else if (windowWidth >= 768) {
            slidesPerView = 2;
        }

        return numSlides > slidesPerView;
    };

    const initializeSwiperBlocks = () => {
        const containerSelectors = '.block-news-listing, .block-discounts-cards, .block-activities-cards';

        swiperConfigs.forEach(({ selector, messages }) => {
            const $swipers = document.querySelectorAll(selector);

            $swipers.forEach((el) => {
                const container = el.closest(containerSelectors);
                const headerBtnPrev = container?.querySelector('.block-news-header .button-swiper-prev');
                const headerBtnNext = container?.querySelector('.block-news-header .button-swiper-next');
                const footerBtnPrev = el.querySelector('.block-news-footer .button-swiper-prev');
                const footerBtnNext = el.querySelector('.block-news-footer .button-swiper-next');

                const enableNavigation = shouldEnableSwiperNavigation(el);

                const allBtnPrev = [headerBtnPrev, footerBtnPrev].filter(Boolean);
                const allBtnNext = [headerBtnNext, footerBtnNext].filter(Boolean);

                new Swiper(el, {
                    modules: [Navigation, Pagination, A11y],
                    slidesPerView: 1,
                    spaceBetween: 24,
                    loop: false,
                    navigation: {
                        nextEl: allBtnNext,
                        prevEl: allBtnPrev,
                        disabledClass: 'swiper-button-disabled',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                    },
                    breakpoints: swiperBreakpoints,
                    on: {
                        init: (swiper) => {
                            updateSlideAccessibility(swiper);
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            updateSlideAccessibility(swiper);
                        },
                    },
                    a11y: {
                        ...baseA11yOptions,
                        prevSlideMessage: prevElement,
                        nextSlideMessage: nextElement,
                    },
                });

                if (!enableNavigation) {
                    container?.classList.add('swiper-navigation-disabled');
                }

                allBtnNext.forEach((button) => {
                    button.addEventListener('click', () => {
                        setTimeout(() => {
                            const { nextLabel } = getAdjacentSlidesLabels(el);
                            announcer.announce(`${messages.next} ${nextLabel}`);
                        }, 0);
                    });
                });

                allBtnPrev.forEach((button) => {
                    button.addEventListener('click', () => {
                        setTimeout(() => {
                            const { prevLabel } = getAdjacentSlidesLabels(el);
                            announcer.announce(`${messages.prev} ${prevLabel}`);
                        }, 0);
                    });
                });
            });
        });
    };

    initializeSwiperBlocks();

    const $highlightsSwipers = document.querySelectorAll('.block-highlights-latest-articles');
    const swiperInstances = [];

    const inithighlightsSwipers = () => {
        if (window.innerWidth < 1024) {
            $highlightsSwipers.forEach((el, index) => {
                if (!el.swiper) {
                    const btnPrev = el.querySelector('.button-swiper-prev');
                    const btnNext = el.querySelector('.button-swiper-next');

                    const swiper = new Swiper(el, {
                        modules: [Navigation, Pagination, A11y],
                        slidesPerView: 'auto',
                        centeredSlides: false,
                        spaceBetween: 0,
                        navigation: {
                            nextEl: btnNext,
                            prevEl: btnPrev,
                        },
                        pagination: {
                            el: '.swiper-pagination',
                            clickable: true,
                        },
                        on: {
                            init: (element) => {
                                updateSlideAccessibility(element);
                            },
                            slideChangeTransitionEnd: (element) => {
                                updateSlideAccessibility(element);
                            },
                        },
                        a11y: {
                            ...baseA11yOptions,
                            prevSlideMessage: nextElement,
                            nextSlideMessage: prevElement,
                        },
                    });
                    swiperInstances[index] = swiper;
                }
            });
        } else {
            swiperInstances.forEach((swiper, index) => {
                if (swiper) {
                    swiper.destroy(true, true);
                    swiperInstances[index] = null;
                }
            });
        }
    };
    inithighlightsSwipers();
    window.addEventListener('resize', inithighlightsSwipers);
});
